import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen w-screen items-center justify-center bg-black">
          <div className="max-w-md px-6 text-center">
            <div className="mb-6 flex justify-center">
              <div className="w-20 h-20 rounded-full bg-red-500/20 border border-red-500/50 flex items-center justify-center">
                <i className="ri-error-warning-line text-4xl text-red-500"></i>
              </div>
            </div>
            <h1 className="text-2xl font-bold text-white mb-3 tracking-wider">
              予期せぬエラーが発生しました
            </h1>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed">
              申し訳ございません。アプリケーションでエラーが発生しました。
              <br />
              トップページに戻ってやり直してください。
            </p>
            {this.state.error && (
              <div className="mb-6 p-4 bg-white/5 border border-white/10 rounded-lg text-left">
                <p className="text-xs text-gray-500 font-mono break-all">
                  {this.state.error.message}
                </p>
              </div>
            )}
            <button
              onClick={() => {
                window.location.href = '/';
              }}
              className="px-6 py-3 bg-white text-black font-bold text-sm tracking-wider rounded-lg hover:bg-gray-200 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line mr-2"></i>
              トップページへ戻る
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}